/* Klarbrise v3 – kleine Premium-Bewegung: Zähler zählen hoch, Haken im Vergleich erscheinen.
   Inhalte stehen immer sofort da (Endwert im HTML); bei „weniger Bewegung“ passiert nichts. */
(function(){
  'use strict';
  var ruhig=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(ruhig||!('IntersectionObserver' in window))return;
  function zaehle(el){
    var ziel=parseFloat(el.getAttribute('data-kb-zahl'));if(isNaN(ziel))return;
    var t0=null,dauer=1100;
    function schritt(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/dauer);var e=1-Math.pow(1-p,3);el.textContent=String(Math.round(ziel*e));if(p<1)requestAnimationFrame(schritt);else el.textContent=String(ziel)}
    requestAnimationFrame(schritt);
  }
  function start(root){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);
      if(e.target.hasAttribute('data-kb-zahl'))zaehle(e.target);else e.target.classList.add('kb-seen')})},{threshold:.35});
    Array.prototype.forEach.call(root.querySelectorAll('[data-kb-zahl],.ng-vgl,[data-kb-seen]'),function(el){io.observe(el)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){start(document)});else start(document);
  document.addEventListener('shopify:section:load',function(e){start(e.target)});
})();
